require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./washington-county-iriss.json") })
        }
      }, "path---washington-county-iriss");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---washington-county-iriss!./.cache/json/washington-county-iriss.json
// module id = 1064
// module chunks = 231608221292675